// Форматирование телефона в формат +7 (XXX) XX XX XX
export const formatPhone = (value) => {
  let digits = value.replace(/\D/g, '');

  // Если начинается не с 7, добавляем 7
  if (digits.length > 0 && digits[0] !== '7') {
    digits = '7' + digits;
  }

  // Ограничиваем до 11 цифр (7 + 10)
  if (digits.length > 11) {
    digits = digits.slice(0, 11);
  }

  // Форматируем номер
  let formatted = '';
  if (digits.length > 0) {
    formatted = '+7';
    if (digits.length > 1) {
      formatted += ' (' + digits.slice(1, 4);
      if (digits.length >= 4) {
        formatted += ')';
      }
      if (digits.length > 4) {
        formatted += ' ' + digits.slice(4, 7);
      }
      if (digits.length > 7) {
        formatted += ' ' + digits.slice(7, 9);
      }
      if (digits.length > 9) {
        formatted += ' ' + digits.slice(9, 11);
      }
    }
  }

  return formatted;
};

// Валидация телефона
export const isValidPhone = (phone) => {
  const digits = phone.replace(/\D/g, '');
  return digits.length === 11 && digits[0] === '7';
};

